<div class="container auth-error mb-3">
    <p>{{message}}</p>
</div>